import React from "react";
import "./FeaturedIn.scss";

import yourstoryLogo          from "../assets/media/yourstory.svg";
import hindustanTimesLogo     from "../assets/media/hindustan-times.svg";
import timesOfIndiaLogo       from "../assets/media/times-of-india.svg";
import indiaTodayLogo         from "../assets/media/india-today.png";
import inc42Logo              from "../assets/media/inc42.svg";
import amarUjalaLogo          from "../assets/media/amar-ujala.png";
import dainikJagranLogo       from "../assets/media/dainik-jagran.png";
import sharkTankLogo          from "../assets/media/shark-tank-india.png";
import joshTalksLogo          from "../assets/media/josh-talks.png";
import theBetterIndiaLogo     from "../assets/media/the-better-india.svg";
import moneycontrolLogo       from "../assets/media/moneycontrol.png";
import entrepreneurIndiaLogo  from "../assets/media/entrepreneur-india.webp";
import dailyhuntLogo          from "../assets/media/dailyhunt.png";
import outlookBusinessLogo    from "../assets/media/outlook-business.svg";
import indiaNewsLogo          from "../assets/media/india-news.png";
import pibLogo                from "../assets/media/pib.jpg";
import nitiFrontierLogo       from "../assets/media/niti-frontier-tech.png";

const LOGOS = [
  { name: "NITI Aayog Frontier Tech Hub", src: nitiFrontierLogo },
  { name: "Shark Tank India",   src: sharkTankLogo },
  { name: "YourStory",          src: yourstoryLogo },
  { name: "Hindustan Times",    src: hindustanTimesLogo },
  { name: "Times of India",     src: timesOfIndiaLogo },
  { name: "India Today",        src: indiaTodayLogo },
  { name: "The Better India",   src: theBetterIndiaLogo },
  { name: "Inc42",              src: inc42Logo },
  { name: "Josh Talks",         src: joshTalksLogo },
  { name: "Amar Ujala",         src: amarUjalaLogo },
  { name: "Dainik Jagran",      src: dainikJagranLogo },
  { name: "Moneycontrol",       src: moneycontrolLogo },
  { name: "Entrepreneur India", src: entrepreneurIndiaLogo },
  { name: "Dailyhunt",          src: dailyhuntLogo },
  { name: "Outlook Business",   src: outlookBusinessLogo },
  { name: "India News",         src: indiaNewsLogo },
  { name: "Press Information Bureau", src: pibLogo },
];

// duplicate for seamless loop
const TRACK = [...LOGOS, ...LOGOS];

export default function FeaturedIn() {
  return (
    <div className="fi">
      <p className="fi__label">FEATURED IN</p>

      <div className="fi__viewport">
        <div className="fi__track">
          {TRACK.map((logo, i) => (
            <div
              className={`fi__item${!logo.src ? " fi__item--text" : ""}`}
              key={i}
              onMouseEnter={(e) => e.currentTarget.classList.add("fi__item--active")}
              onMouseLeave={(e) => e.currentTarget.classList.remove("fi__item--active")}
            >
              {logo.src ? (
                <img
                  src={logo.src}
                  alt={logo.name}
                  className="fi__logo"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    e.currentTarget.parentElement.classList.add("fi__item--text");
                  }}
                />
              ) : null}
              <span className="fi__fallback">{logo.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
